export const config = {
    noticeable: {
        iconWidgetId: process.env.VUE_APP_ICON_WIDGET_ID
    }
}